import Swiper from 'swiper/bundle';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

document.addEventListener('DOMContentLoaded', function() {
  const swiper = new Swiper('.swiper', {
    loop: true,
    fadeEffect: {
      crossFade: true // クロスフェードを有効にする
    },
    autoplay: {
      delay: 5000, // スライド切り替えの間隔を設定（ミリ秒）
      disableOnInteraction: false // ユーザーの操作で自動再生を停止しないようにする
    },
    speed: 1000, // フェードインの速度を設定（ミリ秒）
  });
});